import { AlertColor } from "@mui/material";
import { useState, useCallback } from "react";

export const useErrorSnackbar = () => {
  const [snackBarMessage, setSnackBarMessage] = useState<string>("");
  const [snackBarMode, setSnackBarMode] = useState<AlertColor>("error");

  const showError = useCallback((message: string) => {
    setSnackBarMessage(message);
    setSnackBarMode("error");
  }, []);

  const showSuccess = useCallback((message: string) => {
    setSnackBarMessage(message);
    setSnackBarMode("success");
  }, []);

  const showInfo = useCallback((message: string) => {
    setSnackBarMessage(message);
    setSnackBarMode("info");
  }, []);

  const showWarning = useCallback((message: string) => {
    setSnackBarMessage(message);
    setSnackBarMode("warning");
  }, []);

  const handleCloseSnackbar = useCallback(() => {
    setSnackBarMessage("");
  }, []);

  return {
    snackBarMessage,
    snackBarMode,
    showError,
    showSuccess,
    showInfo,
    showWarning,
    handleCloseSnackbar,
  };
};